import { Card, CardContent } from "../ui/card";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "../ui/tooltip";
import {
  FolderKanban, Euro, TrendingUp, BarChart3, PiggyBank, CheckCircle, Landmark, Wallet, Info,
} from "lucide-react";
import { formatCurrency } from "./projectUtils";

export function ProjectsSummaryCards({ summary }) {
  if (!summary) return null;

  const cards = [
    { icon: FolderKanban, color: "text-primary", label: "Proyectos", value: summary.total_projects, format: false },
    {
      icon: Wallet, color: "text-slate-500", label: "Presupuesto", value: summary.total_budget, format: true,
      infoTip: "Suma del campo 'presupuesto' de la ficha individual de cada proyecto. Puede diferir del 'Previsto total' de la vista económica PG-07 más abajo, que consolida el presupuesto aceptado en convocatoria/consorcio.",
    },
    { icon: Euro, color: "text-red-500", label: "Gasto Real", value: summary.total_expenses, format: true },
    { icon: TrendingUp, color: "text-green-500", label: "Ingresos", value: summary.total_income, format: true },
    {
      icon: BarChart3,
      color: "text-blue-500",
      label: "Balance",
      value: summary.total_balance,
      format: true,
      valueClass: summary.total_balance >= 0 ? "text-green-600" : "text-red-600",
    },
    { icon: PiggyBank, color: "text-amber-500", label: "Subvenciones", value: summary.total_subsidy, format: true },
    { icon: CheckCircle, color: "text-purple-500", label: "Ahorro Financiero", value: summary.total_financial_savings, format: true },
    { icon: Landmark, color: "text-sky-500", label: "Deducción Fiscal", value: summary.total_tax_deduction, format: true },
  ];

  return (
    <TooltipProvider>
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4" data-testid="projects-summary-cards">
      {cards.map(c => (
        <Card key={c.label}>
          <CardContent className="pt-4">
            <div className="flex items-center gap-2">
              <c.icon className={`w-5 h-5 ${c.color}`} />
              <div>
                <p className="text-xs text-muted-foreground flex items-center gap-1">
                  {c.label}
                  {c.infoTip && (
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Info className="w-3 h-3 opacity-60 cursor-help" data-testid={`summary-info-${c.label}`} />
                      </TooltipTrigger>
                      <TooltipContent className="max-w-xs">{c.infoTip}</TooltipContent>
                    </Tooltip>
                  )}
                </p>
                <p className={`text-xl font-bold ${c.valueClass || ""}`}>
                  {c.format ? formatCurrency(c.value) : c.value}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
      {summary.execution_ratio !== null && summary.execution_ratio !== undefined && (
        <Card data-testid="execution-ratio-card">
          <CardContent className="pt-4">
            <p className="text-xs text-muted-foreground">Ejecución s/ Presupuesto</p>
            <p className="text-xl font-bold">{(summary.execution_ratio * 100).toFixed(0)}%</p>
          </CardContent>
        </Card>
      )}
    </div>
    </TooltipProvider>
  );
}
